import { IResourceState } from './IResourceState';
export const initialState: IResourceState = {
  byId: {},
  analytics: { accessedBy: [] },
};
